const mutations = {
	login(state, v) {
		state.isLogin = v;
	},
	SET_COMMENT_ID: (state, commentId) => {
		state.commentId = commentId
	},

	//新闻管理
	SET_NEWS: (state, newsDynamicArr) => {
		state.newsDynamicArr = newsDynamicArr
	},
	 //师资介绍
	SET_COMBAT: (state, combatArr) => {
		state.combatArr = combatArr
	},
	//招生简章
	SET_ENROLLMENT: (state, enrollmentArr) => {
		state.enrollmentArr = enrollmentArr
	},
	//博商出版
	SET_PUBLISH: (state, boSumPublishArr) => {
		state.boSumPublishArr = boSumPublishArr
	},
	//查询案例数据
	SET_CASE: (state, caseArr) => {
		state.caseArr = caseArr
	},
	//查询行业报告数据
	SET_REPORT: (state, reportArr) => {
		state.reportArr = reportArr
	},
	//新闻管理
	SET_COURSE: (state, courseArr) => {
		state.courseArr = courseArr
	},
};
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutation.js